import React, {useEffect, useRef, useState} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, SelectInterface} from "../../components/Utils";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import {useForm} from "react-hook-form";
import {submitNewOffer} from "./OfferRequestSlice";
import {CreateAccount} from "../User/Account/CreateAccountTypes";
import {Offer} from "../Entity/Offer";
import {allCountries} from "../../components/Countries";
import {LocalParams} from "../../components/LocalParams";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import {getUserAccount, getUserAddress} from "../User/UsersSlice";

interface ComponentProps {
  itemsInCartOffer: any,
  remarqueText: string,
  setRemarqueText: React.Dispatch<React.SetStateAction<string>>
}

const OfferRequestForm = ({itemsInCartOffer, remarqueText, setRemarqueText}:ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const tokenOfferCart = LocalParams.getItem('tokenOfferCart') as string
  const countries = React.useMemo(() => allCountries(locale), []);
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const [selectedCountry, setSelectedCountry] = useState<SelectInterface|null>(null);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getUserAccount(true,false));
      dispatch(getUserAddress());
    }
  }, [isAuthenticated]);

  const isRequesting = useSelector((state:RootState) => state.userRdc.isRequesting);
  const userAccount = useSelector((state:RootState) => state.userRdc.userDetail?.customer)
  const userAddresses = useSelector((state: RootState) => state.userRdc.userAddresses)
  const userAccountLastName = userAccount && userAccount.lastName;
  const userAccountFirstName = userAccount && userAccount.firstName;
  const userAccountEmail = userAccount && userAccount.email;
  const userAccountPhoneNumber = userAccount && userAccount.phoneNumber;
  const userAddressStreet = userAddresses && userAddresses[0].street;
  const userAddressZip = userAddresses && userAddresses[0].postcode;
  const userAddressCity = userAddresses && userAddresses[0].city;

  const onSubmit = handleSubmit(({
                                   firstName,
                                   lastName,
                                   email,
                                   street,
                                   zip,
                                   city,
                                   countryCode,
                                   phoneNumber,
                                   notes,
                                 }) => {


    let newRequestOffer : Offer = {
      email: userAccountEmail ? userAccountEmail : email,
      notes : remarqueText ? remarqueText : "",
      locale: GetCurrentLocale(),
      items: itemsInCartOffer.items,
      tokenValue: tokenOfferCart
    }

    let dataCustomerOffer : CreateAccount = {
      firstName: userAccountFirstName ? userAccountFirstName : firstName,
      lastName: userAccountLastName ? userAccountLastName : lastName,
      email: userAccountEmail ? userAccountEmail : email,
      countryCode: selectedCountry ? selectedCountry.value : "BE",
      phoneNumber: userAccountPhoneNumber ? userAccountPhoneNumber : phoneNumber,
      street: userAddressStreet ? userAddressStreet : street,
      zip: userAddressZip ? userAddressZip : zip,
      city: userAddressCity ? userAddressCity : city,
      customerType: "GUEST",
      language: GetCurrentLocale(),
    }

    if(newRequestOffer){
      dispatch(submitNewOffer(newRequestOffer, dataCustomerOffer))
    }
  })
  const remarqueRef = useRef<string>(remarqueText);

  return (
    <form action="#" id="offer-request-form" onSubmit={onSubmit}>
      <h5 className="card-title">{ t('personal_info')}</h5>
      <div className="row">
        {
          isRequesting ? <SpinnerOnTop/> :
            userAccount ?
              <>
                <div className="col-md-6">
                  <label className="form-label strong d-flex">{t('name')}</label>
                  <span>{userAccount.firstName} {userAccount.lastName}</span>
                </div>
                <div className="col-md-6">
                  <label className="form-label strong d-flex">{t('email')}</label>
                  <span>{userAccount.email}</span>
                </div>
                <div className="col-12 mb-3 pt-5">
                  <label className="form-label">{t('add_remark')}</label>
                  <textarea
                    name="notes"
                    className="form-control"
                    required={false}
                    defaultValue={remarqueText}
                    onChange={(e) => (remarqueRef.current = e.target.value)}
                    onBlur={() => setRemarqueText(remarqueRef.current)}
                  />
                </div>
              </>
              : null
        }

      </div>
      <button className="btn btn-primary" type="submit">{t('send_request_offer')}</button>
    </form>
  )
}

export default OfferRequestForm;
